import React from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';

export default function AmbientBackdrop() {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);

  const smoothX = useSpring(mx, { stiffness: 40, damping: 20 });
  const smoothY = useSpring(my, { stiffness: 40, damping: 20 });

  const glow1X = useTransform(smoothX, [-1, 1], [-40, 40]);
  const glow1Y = useTransform(smoothY, [-1, 1], [-30, 30]);
  const glow2X = useTransform(smoothX, [-1, 1], [30, -30]);
  const glow2Y = useTransform(smoothY, [-1, 1], [20, -20]);

  const onMouseMove = (e) => {
    const nx = (e.clientX / window.innerWidth) * 2 - 1;
    const ny = (e.clientY / window.innerHeight) * 2 - 1;
    mx.set(nx);
    my.set(ny);
  };

  return (
    <div
      onMouseMove={onMouseMove}
      className="pointer-events-none fixed inset-0 z-0"
      aria-hidden="true"
    >
      {/* Mouse-following radial glow */}
      <motion.div
        className="absolute top-1/4 left-1/2 w-[700px] h-[700px] -translate-x-1/2 rounded-full bg-indigo-600/10 blur-[130px]"
        style={{ x: glow1X, y: glow1Y }}
      />
      <motion.div
        className="absolute top-1/3 right-0 w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-[110px]"
        style={{ x: glow2X, y: glow2Y }}
      />
    </div>
  );
}